import { RouteType } from '@/main/menu/constants';

import { Managment } from './managment/index';
import { Servis } from './servis';
import { SkladND } from './skladNd';
import { AppointmentList } from './AppointmentList';
import { LabourSales } from './LabourSales';
import { PendingJobsAndSafetyList } from './PendingJobsAndSafetyList';
import { PartSales } from './PartSales';
import { TimeClocking } from './TimeClocking';
import { TechnicianClocking } from './TechnicianClocking';
import { ServiceOrderHistory } from '../administrace/serviceOrderHistory';
import { ServiceDueDetails } from '../administrace/serviceDueDetails';
import { NAME as name } from './constants';
import { AbcFmsAnalysis } from '../sklad/abcFmsAnalysis';
import { AccountReceivable } from './AccountReceivable';
import { DailyPerformance } from './DailyPerformance';
import { InventoryAdjustment } from './InventoryAdjustment';
import { NonReceivedPartsPO } from './NonReceivedPartsPO';
import { OutSourcingDetail } from './OutSourcingDetail';
import { OutstandingRevenue } from './OutstandingRevenue';
import { RevenueDetails } from './RevenueDetails';

import { StockValueMovement } from './StockValueMovement';
import { CashierReport } from './CashierReport';
import { ItemsReceivedDetail } from './ItemsReceivedDetail';
import { WorkInProgress } from './WorkInProgress';
import { RealTimeInventory } from './RealTimeInventory';
import { DetailsOfItemsTransfer } from './DetailsOfItemsTransfer';
import { ReportRequest } from './ReportRequest';
import { AdvancePayment } from './AdvancePayment';
import { StockAgingAnalysis } from './StockAgingAnalysis';

export const menu = {
    name,
    orderAlphabetically: false,
    list: [
        { name: 'StandTiskyDilna', route: Servis.name, routeType: RouteType.name },
        { name: 'StandSklad', route: SkladND.name, routeType: RouteType.name },
        { name: 'StandRepManager', route: Managment.name, routeType: RouteType.name },
        { name: 'ServiceHistory', route: ServiceOrderHistory.name, RouteType: RouteType.name },
        { name: 'ServiceDueDetails', route: ServiceDueDetails.name },
        { name: 'AppointmentList', route: AppointmentList.name, routeType: RouteType.name },
        { name: 'LabourSales', route: LabourSales.name, RouteType: RouteType.name },
        { name: 'AbcFmsAnalysis', route: AbcFmsAnalysis.name },
		{ name: 'AccountReceivable', route: AccountReceivable.name, RouteType: RouteType.name },
        { name: 'PendingJobsAndSafetyList', route: PendingJobsAndSafetyList.name, RouteType: RouteType.name },
        { name: 'PartSales', route: PartSales.name, routeType: RouteType.name },
        { name: 'DailyPerformance', route: DailyPerformance.name, routeType: RouteType.name },
        { name: 'InventoryAdjustment', route: InventoryAdjustment.name, RouteType: RouteType.name },
        { name: 'NonReceivedPartsPO', route: NonReceivedPartsPO.name },
        { name: 'TimeClocking', route: TimeClocking.name },
        { name: 'TechnicianClocking', route: TechnicianClocking.name, routeType: RouteType.name },
        { name: 'OutstandingRevenue', route: OutstandingRevenue.name, routeType: RouteType.name },
        { name: 'RevenueDetails', route: RevenueDetails.name, routeType: RouteType.name },
		{ name: 'WorkInProgress', route: WorkInProgress.name, routeType: RouteType.name },

        { name: 'StockValueMovement', route: StockValueMovement.name, RouteType: RouteType.name },
        { name: 'CashierReport', route: CashierReport.name, routeType: RouteType.name },
        { name: 'ItemsReceivedDetail(GRN)', route: ItemsReceivedDetail.name, RouteType: RouteType.name },
        { name: 'RealTimeInventory', route: RealTimeInventory.name, routeType: RouteType.name },
        { name: 'OutSourcingDetail', route: OutSourcingDetail.name },
        { name: 'DetailsOfItemsTransfer', route: DetailsOfItemsTransfer.name, routeType: RouteType.name },
        { name: 'ReportRequest', route: ReportRequest.name, RouteType: RouteType.name },
        { name: 'AdvancePayment', route: AdvancePayment.name, RouteType: RouteType.name },
		{ name: 'StockAgingAnalysis', route: StockAgingAnalysis.name, RouteType: RouteType.name },

    ],
};
